import { useParams } from 'react-router-dom';

import { useGetProductItemModules } from 'pages/product-full-view/components/product-new-detail-view/queries';
import { FormItemSelectEnum } from 'pages/product-full-view/shared/components';
import { CATEGORY_BLACK_POWDER } from 'pages/product-full-view/components/product-new-detail-view/constants';

export const FormItemCaliberGauge = (props) => {
  const { property, propertyEnums, ...otherProps } = props;

  return (
    <FormItemSelectEnum
      property={property}
      nameFormItem={property.propertyName}
      propertyEnums={propertyEnums}
      {...otherProps}
    />
  );
};

export const FormItemBlackPowder = (props) => {
  const { id: productId } = useParams();

  const { property, propertyEnums, ...otherProps } = props;

  const { basicInformationData } = useGetProductItemModules(productId);

  const isBlackPowder =
    Boolean(basicInformationData?.SubCategory) &&
    basicInformationData?.SubCategory?.toLowerCase() ===
      CATEGORY_BLACK_POWDER?.toLowerCase();

  if (isBlackPowder) {
    return (
      <FormItemSelectEnum
        property={property}
        nameFormItem={property.propertyName}
        propertyEnums={propertyEnums}
        {...otherProps}
      />
    );
  }
  return null;
};
